export const tableHeaderCellProps = {
	sx: {
		padding: "2px 7px",
		height: "30px",
		margin: "0px",
		borderSpacing: "0px",
		borderRight: "1px solid #ddd",
		backgroundColor: "#C18F00",
		color: "white",
		fontSize: "0.9rem",
	},
};

export const tableBodyCellProps = {
	sx: {
		padding: "3px 5px",
		textAlign: "left",
		justifyContent: "flex-start",
		borderRight: "1px solid #C18F00",
		borderBottom: "1px solid #C18F00",
		fontSize: "0.9rem",
	},
};

export const tableBodyCellPropsFirstColumn = {
	sx: {
		padding: "3px 5px",
		textAlign: "left",
		justifyContent: "flex-start",
		borderLeft: "1px solid #C18F00",
		borderRight: "1px solid #C18F00",
		borderBottom: "1px solid #C18F00",
		fontSize: "0.9rem",
	},
};

export const tableBodyCellPropsActionColumn = {
	sx: {
		padding: "3px 5px",
		borderRight: "1px solid #C18F00",
		borderBottom: "1px solid #C18F00",
		fontSize: "0.9rem",
	},
};

export const tableBodyCellPropsAlignContentCenter = {
	sx: {
		padding: "3px 5px",
		textAlign: "center",
		justifyContent: "center",
		borderRight: "1px solid #C18F00",
		borderBottom: "1px solid #C18F00",
		fontSize: "0.9rem",
	},
};

// Novo estilo que combina firstColumn com alinhamento centralizado
export const tableBodyCellPropsFirstColumnCenter = {
	sx: {
		padding: "3px 5px",
		textAlign: "center",
		justifyContent: "center",
		borderLeft: "1px solid #C18F00",
		borderRight: "1px solid #C18F00",
		borderBottom: "1px solid #C18F00",
		fontSize: "0.9rem",
	},
};

// Estilos para campos de filtro responsivos
export const filterFieldProps = {
	size: "small",
	variant: "outlined",
	margin: "dense",
	sx: {
		width: "100%",
		minWidth: "60px", // Largura mínima para campos muito pequenos
		"& .MuiInputBase-root": {
			backgroundColor: "white",
			borderRadius: "3px",
			height: "28px",
			minHeight: "28px",
			fontSize: "0.75rem", // Fonte menor para caber em colunas pequenas
		},
		"& .MuiInputBase-input": {
			padding: "2px 6px",
			fontSize: "0.75rem",
		},
		"& .MuiSelect-select": {
			padding: "2px 6px",
			fontSize: "0.75rem",
		},
		"& .MuiFormLabel-root": {
			fontSize: "0.75rem",
		},
	},
};

// Estilos específicos para selects customizados (como o de Status)
export const customSelectFilterProps = {
	variant: "outlined",
	size: "small",
	margin: "dense",
	sx: {
		width: "100%",
		minWidth: "60px",
		"& .MuiInputBase-root": {
			backgroundColor: "white",
			borderRadius: "3px",
			height: "28px !important",
			minHeight: "28px !important",
			fontSize: "0.75rem",
		},
		"& .MuiInputBase-input": {
			padding: "2px 6px",
			fontSize: "0.75rem",
		},
		"& .MuiOutlinedInput-root": {
			height: "28px !important",
			minHeight: "28px !important",
			fontSize: "0.75rem",
			"& .MuiInputBase-input": {
				height: "28px",
				boxSizing: "border-box",
				padding: "2px 6px",
				fontSize: "0.75rem",
			},
		},
		"& .MuiSelect-select": {
			padding: "2px 6px",
			fontSize: "0.75rem",
		},
		"& .MuiFormLabel-root": {
			fontSize: "0.75rem",
		},
		"& .MuiChip-root": {
			height: "20px",
			fontSize: "0.65rem",
			"& .MuiChip-label": {
				padding: "0 4px",
				fontSize: "0.65rem",
			},
		},
	},
};

// Estilos para campos de data
export const dateFilterProps = {
	...filterFieldProps,
	sx: {
		...filterFieldProps.sx,
		"& .MuiInputBase-root": {
			...filterFieldProps.sx["& .MuiInputBase-root"],
			minWidth: "90px", // Data precisa de um pouco mais de espaço
		},
	},
};

export const getTableHeaderCellProps = () => ({
	muiTableHeadCellProps: {
		...tableHeaderCellProps,
		align: "center",
	},
});

export const getTableBodyCellProps = (columnType = "") => ({
	muiTableBodyCellProps:
		columnType === "firstColumn"
			? tableBodyCellPropsFirstColumn
			: columnType === "firstColumnCenter"
			? tableBodyCellPropsFirstColumnCenter
			: columnType === "actionColumn"
			? tableBodyCellPropsActionColumn
			: columnType === "alignContentCenter"
			? tableBodyCellPropsAlignContentCenter
			: tableBodyCellProps,
});

// Função para obter props dos campos de filtro baseado no tipo
export const getFilterFieldProps = (filterType = "text") => {
	switch (filterType) {
		case "date":
			return dateFilterProps;
		case "select":
		case "custom":
			return customSelectFilterProps;
		default:
			return filterFieldProps;
	}
};
